import { inheritOutlookPrivacyMode } from '@/analytics/privacy/outlook-continuation-privacy'

/**
 * Opens a standalone viewer URL in a new tab and reports whether the browser
 * actually opened it. `window.open` with a 'noopener' feature always returns
 * null, which makes popup-blocked opens indistinguishable from successes —
 * callers gate analytics (e.g. citator_panel_opened) on the result, so we open
 * without the feature and sever the opener reference manually instead.
 */
export function openStandaloneViewerTab(viewerUrl: string): boolean {
  const openedWindow = window.open(inheritOutlookPrivacyMode(viewerUrl), '_blank')
  if (!openedWindow) return false
  openedWindow.opener = null
  return true
}
